import { render, staticRenderFns } from "./SettingMultiple.vue?vue&type=template&id=e26ad9a8"
import script from "./SettingMultiple.vue?vue&type=script&lang=ts"
export * from "./SettingMultiple.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports